<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
let isDelete = { "1": "启用", "2": "禁用" };
let pushType = { "1": "发送验证码", "2": "重置密码" };
let codeStatus = { "0": "未使用", "1": "已使用", "2": "已失效", "3": "发送失败" };
let receiveTunnel = { "-1": "伪短信", "3": "麦讯通" };
export default {
  name: "messageLog",
  components: {
    genericList
  },
  data() {
    return {
      apiUrls: {
        query: URL.smsMessageLog.query,
        addOrUpdate: URL.smsMessageLog.addOrUpdate,
        deleteBatchIds: URL.smsMessageLog.deleteBatchIds
      },
      formCols: [
        { title: '短信账号', field: 'receiveTunnel' },
        { title: '短信分类', field: 'pushType', type: 2, optionList: pushType },
        { title: '收件人手机号', field: 'phone' },
        { title: '发送状态', field: 'codeStatus', type: 2, optionList: codeStatus },
        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add'), auth: 'business:smsMessageLog:save' }
      ],
      updateCols: [

      ],
      tableCols: [
        {
          title: '短信账号', field: 'receiveTunnel', render: (data) => {
            return receiveTunnel[data];
          }
        },
        { title: '验证码', field: 'code' },
        { title: '短信内容', field: 'content' },
        {
          title: '短信分类', field: 'pushType', render: (data) => {
            return pushType[data];
          }
        },
        { title: '收件人会员号', field: 'userCode' },
        { title: '收件人手机号码', field: 'phone' },
        { title: '发送时间', field: 'createDate' },
        {
          title: '发送状态', field: 'codeStatus', render: (data) => {
            return codeStatus[data];
          }
        },
        { title: '接口返回id', field: 'orderId' },
        { title: '接口返回信息', field: 'orderMsg' },
        { field: window.$t('business.bt.delete'), title: window.$t('business.bt.operation'), size: "mini", click: "delete", type: "primary", icon: "el-icon-delete", auth: 'business:smsMessageLog:delete' }
      ]
    };
  }
}
</script>